export const getReplacedLabel = (label = "", category = ""): string =>
  label.replace(/{{Category}}/gi, category);
